// Azure APIs
// export const ADMIN_API_URL = 'http://mac.mas.deloitteinnovation.space/api';

// Local testing
//export const ADMIN_API_URL = "http://4.156.105.81/api";
//export const ADMIN_API_URL = "http://registry.mas.deloitteinnovation.space/api";
//export const ADMIN_API_URL = "http://localhost:8000/api";


export const ADMIN_API_URL = process.env.REACT_APP_API_URL;
